export default __webpack_public_path__ + "static/img/download_app_install_image.a69ef43.png";